import { observable } from 'mobx';
// import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

import Macy from 'macy';

class MapStore extends BaseStore {
  @observable wallpaperData

  @observable wallMainTimer;
  @observable isWallShow = false;

  /**
   * 实例化瀑布流
   */
  createWall() {
    const that = this;
    const container = document.querySelector('#wallMain');
    if (!container) return;

    // 等待所有图片加载完成
    const images = container.querySelectorAll('img');
    const loadPromises = Array.from(images).map(img =>
      new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve; // 加载失败也继续，避免阻塞
      })
    );

    Promise.all(loadPromises).then(() => {
      that.masonry = new Macy({
        container: '#wallMain',
        trueOrder: false,
        waitForImages: true,
        useOwnImageLoader: false,
        mobileFirst: false,
        debug: true,
        refresh: false,
        columns: 2,
        margin: { x: 8, y: 8 }
      });
    });
  }
  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  use() {
    super.use();
    const data = useFunLinkPageData();

    useEffect(
      () => {
        if (!data) {
          return;
        }
        // console.log('data', data);
        this.wallpaperData = data.wallpaperData
        this.createWall();
        if (this.wallMainTimer) {
          clearTimeout(this.wallMainTimer);
        }
        this.wallMainTimer = setTimeout(() => {
          this.isWallShow = true;
          this.masonry?.recalculate();
        }, 400);
      },
      [data]
    );
    useEffect(() => {
      // 窗口变化时重新计算布局
      const handleResize = () => {
        this.masonry?.recalculate();
      };
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    useMount(async () => {


    });
  }
}

export default MapStore;
